import ListingDetailAttachmentForm from '@Forms/ListingDetailAttachmentForm';
import FitsToForm from '@Forms/FitsToForm';
import ListingDetailSection from '@Sections/ListingDetailSection';
import SpecsSection from '@Sections/SpecsSection';
import PriceSection from '@Sections/PriceSection';

class EquipmentInfoSection extends React.Component {

    //set the react state to the the same values as the model
    static modelToState(props) {
        return {
            ListingDetailViewModel: props.model.ListingDetailViewModel,
            SpecsViewModel: props.model.SpecsViewModel,
            FitsToViewModel: props.model.FitsToViewModel,
            PriceViewModel: props.model.PriceViewModel,
            MediaViewModel: props.model.MediaViewModel,
            ContactViewModel: props.model.ContactViewModel,
            CatMakeModelValid: props.model.CatMakeModelValid,
            IsAttachment: props.model.IsAttachment,
            validatorEquipmentInfo: props.model.validatorEquipmentInfo,
            QueryString: props.model.QueryString,
            CurrentSite: props.model.CurrentSite,
            Translations: props.model.Translations,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
            IsInTranslationEditorMode: props.model.IsInTranslationEditorMode,
            IsRegisteredUser: props.model.IsRegisteredUser,
            IncludeAttachment: props.model.IncludeAttachment,
            IsRearrangedDetailsPage: props.model.IsRearrangedDetailsPage,
        };
    }

    //The props is the model passed from the view(cshtml)
    constructor(props) {
        super(props);

        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleFormUpdate = this.handleFormUpdate.bind(this);
        this.validateEquipmentInfo = this.validateEquipmentInfo.bind(this);
        this.validateAircraftEquipmentInfo = this.validateAircraftEquipmentInfo.bind(this);
        this.changeListingType = this.changeListingType.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);

        //updates the parent's validator to use this method 
        var masterViewState = this.props.model;
        masterViewState.validatorEquipmentInfo = this.validateEquipmentInfo;
        this.props.handleFormUpdate(masterViewState);

        this.state = EquipmentInfoSection.modelToState(props);

        this.fitsToReference = React.createRef();
    }

    componentWillReceiveProps(props) {
        this.setState({
            ListingDetailViewModel: props.model.ListingDetailViewModel,
            SpecsViewModel: props.model.SpecsViewModel,
            FitsToViewModel: props.model.FitsToViewModel,
            PriceViewModel: props.model.PriceViewModel,
            MediaViewModel: props.model.MediaViewModel,
            ContactViewModel: props.model.ContactViewModel,
            IsAttachment: props.model.IsAttachment,
            Translations: props.model.Translations,
            IsInTranslationEditorMode: props.model.IsInTranslationEditorMode,
            IncludeAttachment: props.model.IncludeAttachment,
            IsRearrangedLandingPage: props.model.IsRearrangedLandingPage,
            IsRearrangedDetailsPage: props.model.IsRearrangedDetailsPage,
        });
    }

    //executes a command when you click on a button
    handleButtonClick(button) {
        switch (button) {
            case "done":
                var bNoErrors = this.validateEquipmentInfo(true);

                if (bNoErrors) {
                    // fire the addListingEquipment datalayer event here
                    if (!dataLayer_ContainsEvent(gTagEvents.addListingEquipment)) {
                        window.dataLayer.push({
                            "event": gTagEvents.addListingEquipment
                        });
                    }

                    //check for consignment
                    if ($("#header-accordion-" + ConsignmentSectionID.toString()).length && this.props.model.ConsignmentViewModel && this.props.model.ContactViewModel) {
                        ConsignmentHeaderAccordion(ConsignmentSectionID, this.props.model.ConsignmentViewModel, this.props.model.ContactViewModel.CRMID > 0);
                    }
                    else {
                        EnterInfoDone(this.props.model.IsRearrangedDetailsPage, this.props.model.CurrentSite);
                    }
                }
                break;
            default:
                break;
        }
    }

    handleKeyDown(e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.handleButtonClick("done");
            let tagetElement = this.state.IsRearrangedSite ? document.getElementById("dropbox") : document.getElementById("PrivacyBtn");
            setTimeout(() => {
                if (tagetElement) {
                    tagetElement.focus();
                }
            }, 0);
        }
    }

    //updates the state in View with new values when they change. 
    handleFormUpdate(Model) {
        this.setState({
            ListingDetailViewModel: Model.ListingDetailViewModel,
            validatorListingDetail: Model.validatorListingDetail,
            SpecsViewModel: Model.SpecsViewModel,
            showUnitSwitchModal: Model.SpecsViewModel.showUnitSwitchModal || this.state.showUnitSwitchModal,
            FitsToViewModel: Model.FitsToViewModel,
            validatorFitsTo: Model.validatorFitsTo || this.state.validatorFitsTo,
            MediaViewModel: Model.MediaViewModel,
            validatorMedia: Model.validatorMedia,
            PriceViewModel: Model.PriceViewModel,
            validatorPrice: Model.validatorPrice,
            ContactViewModel: Model.ContactViewModel,
            validatorContact: Model.validatorContact,
            validatorEquipmentInfo: Model.validatorEquipmentInfo,
            CurrentSite: Model.CurrentSite,
            Translations: Model.Translations,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors,
            IsInTranslationEditorMode: Model.IsInTranslationEditorMode,
            IncludeAttachment: Model.IncludeAttachment,
            IsRearrangedLandingPage: Model.IsRearrangedLandingPage,
            IsRearrangedDetailsPage: Model.IsRearrangedDetailsPage
        });

        //pass update up to MasterView
        this.props.handleFormUpdate(Model);
    }

    changeListingType(field, bIsAttachment) {
        if (!this.state.IsInTranslationEditorMode) {
            this.props.changeListingType(field, bIsAttachment);
        }
    }

    validateEquipmentInfo(bSaveXML) {
        if (this.state.CurrentSite == "Aircraft") {
            return this.validateAircraftEquipmentInfo(true);
        }
        else {
            var state = this.state;
            var hasErrors = false;
            if (bSaveXML == null)
                bSaveXML = false;

            hasErrors = this.state.validatorListingDetail(false);

            if (hasErrors) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            else {
                if (state.IsAttachment) {
                    if (!this.props.model.ExcludeFitsTo) {
                        hasErrors = this.state.validatorFitsTo(false);
                    }
                }
                else {
                    hasErrors = this.state.ValidateAndSaveSpecs(false);
                }
            }

            if (!hasErrors && !this.props.model.IsConsignment)
                hasErrors = this.state.validatorPrice(false);

            if (!hasErrors && bSaveXML) {
                //build View models with only necessary info
                var ListingDetailViewModel = {
                    SystemOfMeasurement: state.ListingDetailViewModel.SystemOfMeasurement,
                    ManufacturerSelected: state.ListingDetailViewModel.ManufacturerSelected,
                    ModelSelected: state.ListingDetailViewModel.ModelSelected,
                    SerialVIN: state.ListingDetailViewModel.SerialVIN,
                    YearSelected: state.ListingDetailViewModel.YearSelected,
                    EquipmentIdentifier: state.ListingDetailViewModel.EquipmentIdentifier,
                    StockNumber: state.ListingDetailViewModel.StockNumber,
                    Condition: state.ListingDetailViewModel.Condition,
                    Description: state.ListingDetailViewModel.Description,
                    Quantity: state.ListingDetailViewModel.Quantity,
                    Weight: state.ListingDetailViewModel.Weight,
                    CategorySelected: state.ListingDetailViewModel.CategorySelected,
                    BaseCatID: state.ListingDetailViewModel.BaseCatID,
                    LocationViewModel: state.ListingDetailViewModel.LocationViewModel
                }

                if (!state.IsAttachment) {
                    var SpecsViewModel = {
                        SpecPage: state.SpecsViewModel.currentPage,
                        FormInputs: state.SpecsViewModel.FormInputs,
                        SerialVIN: state.ListingDetailViewModel.SerialVIN,
                        Category: state.SpecsViewModel.Category,
                        Manufacturer: state.ListingDetailViewModel.ManufacturerSelected,
                        Model: state.ListingDetailViewModel.ModelSelected,
                        Year: state.ListingDetailViewModel.YearSelected,
                    }
                }

                var PriceViewModel = {
                    CurrencyCodeSelected: state.PriceViewModel.CurrencyCodeSelected,
                    Price: state.PriceViewModel.Price,
                    FEClicks: state.PriceViewModel.FEClicks,
                    ExcludeGoodsAndServicesTax: state.PriceViewModel.ExcludeGoodsAndServicesTax
                }

                if (state.CurrentSite == "Controller" ||
                    state.CurrentSite == "Aviation Trader" ||
                    state.CurrentSite == "Controller EMEA") {
                    PriceViewModel.ForSale = state.PriceViewModel.ForSale;
                    PriceViewModel.LeasePrice = state.PriceViewModel.LeasePrice;
                    PriceViewModel.ForLease = state.PriceViewModel.ForLease;
                    PriceViewModel.FractionalPrice = state.PriceViewModel.FractionalPrice;
                    PriceViewModel.FractionalPercent = state.PriceViewModel.FractionalPercent;
                    PriceViewModel.ForFractional = state.PriceViewModel.ForFractional;
                }

                if (state.CurrentSite == "RentalYard") {
                    PriceViewModel.ForRent = true;
                    PriceViewModel.DailyRentalPrice = state.PriceViewModel.DailyRentalPrice;
                    PriceViewModel.WeeklyRentalPrice = state.PriceViewModel.WeeklyRentalPrice;
                    PriceViewModel.MonthlyRentalPrice = state.PriceViewModel.MonthlyRentalPrice;
                }

                var objectToSend = {
                    ListingDetailViewModel: ListingDetailViewModel,
                    SpecsViewModel: SpecsViewModel,
                    PriceViewModel: PriceViewModel,
                    EmailVerified: state.ContactViewModel.EmailVerified,
                    IsAttachment: state.IsAttachment
                }

                //save this xml
                if (bSaveXML) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", '/listinginput/details/SaveListingInfoXML' + this.state.QueryString, true);
                    xhr.setRequestHeader("Content-type", "application/json");
                    xhr.send(JSON.stringify(objectToSend));
                }

                return true;
            }
            else {
                return !hasErrors;
            }
        }
    }

    validateAircraftEquipmentInfo(bSaveXML) {
        var state = this.state;
        var hasErrors = false;
        if (bSaveXML == null)
            bSaveXML = false;

        hasErrors = this.state.validatorListingDetail(false);

        if (hasErrors)
            window.scrollTo({ top: 0, behavior: 'smooth' });

        if (!hasErrors) {

            //add tail # to specs as regnumber
            if (state.ListingDetailViewModel.CategorySelected != "0" && state.ListingDetailViewModel.CategorySelected != null)
                state.SpecsViewModel.FormInputs["RegNumber"].Value = state.ListingDetailViewModel.TailNumber;

            //build View models with only necessary info
            var ListingDetailViewModel = {
                ManufacturerSelected: state.ListingDetailViewModel.ManufacturerSelected,
                SystemOfMeasurement: state.ListingDetailViewModel.SystemOfMeasurement,
                ModelSelected: state.ListingDetailViewModel.ModelSelected,
                SerialVIN: state.ListingDetailViewModel.SerialVIN,
                YearSelected: state.ListingDetailViewModel.YearSelected,
                EquipmentIdentifier: state.ListingDetailViewModel.EquipmentIdentifier,
                StockNumber: state.ListingDetailViewModel.StockNumber,
                Condition: state.ListingDetailViewModel.Condition,
                Description: state.ListingDetailViewModel.Description,
                Quantity: state.ListingDetailViewModel.Quantity,
                Weight: state.ListingDetailViewModel.Weight,
                CategorySelected: state.ListingDetailViewModel.CategorySelected,
                BaseCatID: state.ListingDetailViewModel.BaseCatID,
            }

            var SpecsViewModel = {
                Category: state.ListingDetailViewModel.CategorySelected,
                Manufacturer: state.ListingDetailViewModel.ManufacturerSelected,
                Model: state.ListingDetailViewModel.ModelSelected,
                SpecPage: state.SpecsViewModel.currentPage,
                FormInputs: state.SpecsViewModel.FormInputs,
                SerialVIN: state.SpecsViewModel.SerialVIN,
                Year: state.SpecsViewModel.Year,
            }

            var objectToSend = {
                ListingDetailViewModel: ListingDetailViewModel,
                SpecsViewModel: SpecsViewModel,
                EmailVerified: state.ContactViewModel.EmailVerified,
            }

            //save this xml
            if (bSaveXML) {
                var xhr = new XMLHttpRequest();
                xhr.open("POST", '/listinginput/details/SaveAircraftEquipmentInfoXML' + this.state.QueryString, true);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
            }

            return true;
        }
        return false;
    }

    onCategorySelected(catID) {
        var dataToSend = {
            sCategoryID: catID
        };

        var xhrFTCategoryUpdate = new XMLHttpRequest();
        xhrFTCategoryUpdate.onreadystatechange = function () {
            if (xhrFTCategoryUpdate.readyState == 4) {
                var cats = JSON.parse(xhrFTCategoryUpdate.response);
                var ftVM = this.state.FitsToViewModel;
                ftVM.CategoriesList = cats.categoryOptions;
                ftVM.IndustryList = (cats.industries || []);
                this.setState({
                    FitsToViewModel: ftVM
                }, function () {
                    if (this.state.ListingDetailViewModel.ManufacturerSelected &&
                        this.state.ListingDetailViewModel.ModelSelected && this.state.ListingDetailViewModel.CategorySelected) {
                        this.onAttachmentEntered();
                    }
                    else {
                        //save fits tos xml to sync with the UI
                        var objectToSend = {
                            oFitsToViewModel: this.state.FitsToViewModel
                        }

                        var xhr = new XMLHttpRequest();
                        xhr.open("POST", '/listinginput/fitsto/SaveObjectXML' + this.state.QueryString, true);
                        xhr.setRequestHeader("Content-type", "application/json");
                        xhr.send(JSON.stringify(objectToSend));

                        this.fitsToReference.current.rebuildFitsToTable(this.state);
                    }
                });
            }
        }.bind(this);

        xhrFTCategoryUpdate.open("POST", "/listinginput/fitsto/UpdateFitsToCategoriesByCategoryID" + this.state.QueryString, false);
        xhrFTCategoryUpdate.setRequestHeader("Content-type", "application/json");
        xhrFTCategoryUpdate.send(JSON.stringify(dataToSend));
    }

    onAttachmentEntered() {
        var state = this.state;
        var dataToSend = {
            nCategoryID: state.ListingDetailViewModel.CategorySelected,
            sManu: state.ListingDetailViewModel.ManufacturerSelected,
            sModel: state.ListingDetailViewModel.ModelSelected,
            sTLD: state.ContactViewModel.TopLevelDomain
        };
        this.state.FitsToViewModel.FitsToList = [];

        var xhrFTRequest = new XMLHttpRequest();
        xhrFTRequest.onreadystatechange = function () {
            if (xhrFTRequest.readyState == 4) {
                var ftVM = this.state.FitsToViewModel;
                var ftItems = JSON.parse(xhrFTRequest.response);
                for (var fi = 0; fi < ftItems.length; fi++) {
                    var ftItem = ftItems[fi];
                    ftVM.FitsToList.push(ftItem);
                }
                this.setState({
                    FitsToViewModel: ftVM
                }, function () {
                    this.fitsToReference.current.rebuildFitsToTable(this.state);
                });
            }
        }.bind(this);

        xhrFTRequest.open("POST", "/listinginput/base/GetFitsToItemsByCatMakeModel" + this.state.QueryString, false);
        xhrFTRequest.setRequestHeader("Content-type", "application/json");
        xhrFTRequest.send(JSON.stringify(dataToSend));
    }

    RequiredSpecsRender(props, showSpecsorFitsTo) {
        return (
            <>
                {showSpecsorFitsTo &&
                    (this.state.IsAttachment ?
                        (!this.props.model.ExcludeFitsTo &&
                            <FitsToForm
                                ref={this.fitsToReference}
                                masterViewModel={this.state}
                                model={this.state.FitsToViewModel}
                                handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                            />
                        )
                        :
                            <SpecsSection
                                masterViewModel={this.state}
                                model={this.state.SpecsViewModel}
                                handleFormUpdate={(e) => { this.props.handleFormUpdate(e); }}
                            />
                    )}
                {!this.state.IsRearrangedDetailsPage && props.model.CurrentSite !== "Aircraft" ?
                    <PriceSection
                        masterViewModel={this.state}
                        model={this.state.PriceViewModel}
                        handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                    /> : null}
            </>);
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    //the html and react components to render
    render() {

        var showSpecsorFitsTo = true;

        //the if statements that will determine what components to show
        if (this.state.CurrentSite == "Aircraft") {
            showSpecsorFitsTo = false;
        }

        let showAttachment = this.state.IncludeAttachment;
        let showLivestockHayStrawSwitcher = false;

        if (this.state.CurrentSite == "LivestockMarket" || this.state.CurrentSite == "EquineMarket") {
            showAttachment = false;
            showLivestockHayStrawSwitcher = true;
        }

        let whatAreYouSelling = [];
        if (showAttachment) {
            const equipmentStyle = !this.state.IsAttachment ? { marginLeft: '0px', marginRight: '0px', background: '#3e3e3f', color: '#fff', border: '1px #123a40 solid' } : { marginLeft: '0px', marginRight: '0px' };
            const attachmentStyle = this.state.IsAttachment ? { background: '#3e3e3f', color: '#fff', border: '1px #123a40 solid' } : {};
            whatAreYouSelling.push(
                <div key="radioAttachment" className="rearranged-equipment-selector" tabIndex={0}>
                    <h1 style={{ marginTop:"0px" }}>{this.getTranslation("WhatAreYouSelling")}</h1>
                    <div className="box-select" style={{ marginLeft: '0px', marginBottom: '10px' }}>
                        <fieldset style={{ border: '0', marginLeft: '0px', paddingLeft: '0px' }}>
                            <legend style={{ display: "none" }}>{this.getTranslation("WhatAreYouSelling")}</legend>
                            <div style={{ marginLeft: '0px' }}>
                                <label htmlFor="isEquipment" style={equipmentStyle} className="label">
                                    <input type="radio" className="radio" id="isEquipment" onChange={(e) => { this.changeListingType("attachment", false); }} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); this.changeListingType("attachment", false); } }} checked={!this.state.IsAttachment} />
                                    <strong>{this.getTranslation("EquipmentToggle")}</strong>
                                </label>
                            </div>
                            <div>
                                <label htmlFor="isAttachment" style={attachmentStyle} className="label">
                                    <input type="radio" className="radio" id="isAttachment" onChange={(e) => { this.changeListingType("attachment", true); }} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); this.changeListingType("attachment", true); } }} checked={this.state.IsAttachment} />
                                    <strong>{this.getTranslation("AttachmentToggle")}</strong>
                                </label>
                            </div>
                        </fieldset>
                    </div>
                </div>
            );
        }
        else if (showLivestockHayStrawSwitcher) {
            let labelText = "Livestock";
            if (this.state.CurrentSite == "EquineMarket") {
                labelText = "Horse";
            }
            const livestockStyle = this.state.IsLivestock ? { marginRight: '0px', background: '#725146', color: '#fff', border: '1px #522e1f solid' } : { marginRight: '0px', background: '#555555', color: '#fff', border: 'none' };
            const cropStyle = this.state.IsCrop ? { background: '#725146', color: '#fff', border: '1px #522e1f solid' } : { background: '#555555', color: '#fff', border: 'none' };
            whatAreYouSelling.push(
                <div key="radioLivestockCrop" tabIndex={0}>
                    <h1>{this.getTranslation("WhatAreYouSelling")}</h1>
                    <br />
                    <div className="box-select">
                        <fieldset style={{ border: '0', marginLeft: '0px', paddingLeft: '0px' }}>
                            <legend style={{ display: "none" }}>{this.getTranslation("WhatAreYouSelling")}</legend>
                            <div>
                                <label htmlFor="isLivestock" style={livestockStyle} className="label">
                                    <input type="radio" className="radio" id="isLivestock" onChange={(e) => { this.changeListingType("livestockCrop", false); }} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); this.changeListingType("livestockCrop", false); } }} checked={this.state.IsLivestock} />
                                    <strong>{labelText}</strong>
                                </label>
                            </div>
                            <div>
                                <label htmlFor="isCrop" style={cropStyle} className="label">
                                    <input type="radio" className="radio" id="isCrop" onChange={(e) => { this.changeListingType("livestockCrop", true); }} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); this.changeListingType("livestockCrop", true); } }} checked={this.state.IsCrop} />
                                    <strong>Hay / Straw</strong>
                                </label>
                            </div>
                        </fieldset>
                    </div>
                </div>
            );

            //Market as selector for LSM
            const privateTreatyStyle = this.state.SaleType == 'Private Treaty' ? { marginRight: '0px', background: '#725146', color: '#fff', border: '1px #522e1f solid' } : { marginRight: '0px', background: '#555555', color: '#fff', border: 'none' };
            const onlineAuctionStyle = this.state.SaleType == 'Online Auction' ? { background: '#725146', color: '#fff', border: '1px #522e1f solid' } : { background: '#555555', color: '#fff', border: 'none' };
            whatAreYouSelling.push(
                <div key="radioMarketAs" tabIndex={0}>
                    <h2 style={{ fontSize: '20px', display: 'inline-block' }}>Market as</h2>
                    <br />
                    <div className="box-select">
                        <fieldset style={{ border: '0', marginLeft: '0px', paddingLeft: '0px' }}>
                            <legend style={{ display: "none" }}>{this.getTranslation("WhatAreYouSelling")}</legend>
                            <div>
                                <label htmlFor="marketAsPT" style={privateTreatyStyle} className="label">
                                    <input type="radio" className="radio" id="marketAsPT" value="Private Treaty" onChange={(e) => { this.handleFieldChanged("SaleType", e.target.value); }} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); this.handleFieldChanged("SaleType", e.target.value); } }} checked={this.state.SaleType == 'Private Treaty'} />
                                    <strong>Private Treaty</strong>
                                </label>
                            </div>
                            <div>
                                <label htmlFor="marketAsOA" style={onlineAuctionStyle} className="label">
                                    <input type="radio" className="radio" id="marketAsOA" value="Online Auction" onChange={(e) => { this.handleFieldChanged("SaleType", e.target.value); }} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); this.handleFieldChanged("SaleType", e.target.value); } }} checked={this.state.SaleType == 'Online Auction'} />
                                    <strong>Online Auction</strong>
                                </label>
                            </div>
                        </fieldset>
                    </div>
                </div>
            );
        }
        else {
            whatAreYouSelling.push(
                <div key="noRadioHeading" tabIndex={0}>
                    <h1>{this.state.CurrentSite == "Aircraft" ? this.getTranslation("UploadAndShareYourAicraftPhotos") : this.getTranslation("WhatAreYouSelling")}</h1>
                </div>
            );
        }

        return (
            <div className="accordion cf" id="accordion-content-2">
                {this.state.IsRearrangedDetailsPage ?
                    <div>
                        {whatAreYouSelling}
                    </div> : null}
                {this.state.IsAttachment ? //Details For attachment.
                    <ListingDetailAttachmentForm
                        masterViewModel={this.state}
                        model={this.state.ListingDetailViewModel}
                        handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                        onAttachmentEntered={() => { this.onAttachmentEntered(); }}
                        onCategorySelected={(catID) => { this.onCategorySelected(catID); }}
                    />
                    :
                    <ListingDetailSection
                        masterViewModel={this.state}
                        model={this.state.ListingDetailViewModel}
                        specsViewModel={this.state.SpecsViewModel}
                        handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                    />
                }
                {this.RequiredSpecsRender(this.props, showSpecsorFitsTo)}
                <button role="link" className="form-btn" id="info-done-btn" onKeyDown={(e) => { this.handleKeyDown(e)}} onMouseUp={(e) => { this.handleButtonClick("done"); }}>{this.getTranslation("DoneWithVehicleInformation")}</button>
            </div>
        );
    }
}

export default EquipmentInfoSection;
global.EquipmentInfoSection = EquipmentInfoSection;